import { render, staticRenderFns } from "./centerBottom.vue?vue&type=template&id=0c076fa2&scoped=true&"
import script from "./centerBottom.vue?vue&type=script&lang=js&"
export * from "./centerBottom.vue?vue&type=script&lang=js&"
import style0 from "./centerBottom.vue?vue&type=style&index=0&id=0c076fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c076fa2",
  null
  
)

export default component.exports